"use client";

import { useEffect, useRef } from "react";
import { ShopEvent, ShopEventType } from "@jurni/schemas";
import { useShopEventsContext } from "@/app/providers/shop-events-provider";

type ShopEventOf<T extends ShopEventType> = Extract<ShopEvent, { type: T }>;

const isEventOfType = <T extends ShopEventType>(
  event: ShopEvent,
  type: T,
): event is ShopEventOf<T> => event.type === type;

export const useShopEvents = <T extends ShopEventType>(
  type: T,
  handler: (event: ShopEventOf<T>) => void,
) => {
  const { subscribe } = useShopEventsContext();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    return subscribe((message) => {
      if (isEventOfType(message.event, type)) {
        handlerRef.current(message.event);
      }
    });
  }, [subscribe, type]);
};
